import { Model } from "pinia-orm";

export default class Document extends Model {
  static name = "DocumentStatus";
  static entity = "documentStatuses";
  static primaryKey = "uuid";

  static fields() {
    return {
      uuid: this.uid(""),
      name: this.string(""),
    };
  }
}
